<template lang="pug">
.collar-text(ref="root")
</template>
<script setup lang="ts">
import { computed, onMounted, useTemplateRef, watch } from 'vue'
import { renderCollarText } from '@zeus'
import { useRogue } from '@/js/services/Rogue'

const props = withDefaults(defineProps<{
  options: Parameters<typeof renderCollarText>[0],
  sku: string,
  angle?: number,
}>(), { angle: 0 })

const rogue = useRogue()
const root = useTemplateRef<HTMLElement>('root')

const renderKey = computed(() => [
  props.options.collarFont.val,
  props.options.collarColor.val,
  props.options.collarTextTop.val,
  props.options.collarTextBottom.val,
].join(''))

async function update() {
  if (!root.value) {
    return
  }

  const el = root.value.children?.[0] as HTMLElement | undefined
  const { svg } = await renderCollarText(props.options, props.angle, document, rogue.fetch.bind(rogue), props.sku, el)

  if (!root.value.children.length) {
    root.value.appendChild(svg)
  }
}

watch(renderKey, () => {
  if (root.value) {
    update()
  }
})

onMounted(() => {
  setTimeout(() => update(), 100)
})
</script>
